import axios, { AxiosInstance } from 'axios'
import { api } from './client'

export interface HumanLoginResponse {
  access_token: string
  human: HumanResponse
}

export interface HumanResponse {
  id: number
  company_id: number
  username: string
  display_name: string
  avatar: string | null
  is_active: boolean
  status: 'online' | 'offline' | 'busy'
  max_sessions: number
  created_at: string
  updated_at: string
}

export interface HumanCreate {
  username: string
  password: string
  display_name: string
  avatar?: string
  max_sessions?: number
}

export interface HumanUpdate {
  display_name?: string
  avatar?: string
  is_active?: boolean
  max_sessions?: number
}

export interface HumanLoadItem {
  id: number
  display_name: string
  status: string
  max_sessions: number
  current_sessions: number
}

// 管理员用（使用普通 admin token）
export const humanAdminApi = {
  list: (): Promise<HumanResponse[]> =>
    api.get('/humans'),

  create: (data: HumanCreate): Promise<HumanResponse> =>
    api.post('/humans', data),

  update: (id: number, data: HumanUpdate): Promise<HumanResponse> =>
    api.put(`/humans/${id}`, data),

  getLoad: (): Promise<HumanLoadItem[]> =>
    api.get('/humans/load'),
}

// 坐席工作台用（使用坐席 token）
const createHumanApiClient = (): AxiosInstance => {
  const instance = axios.create({ baseURL: import.meta.env.VITE_API_BASE_URL || '/api/v1', timeout: 30000 })
  instance.interceptors.request.use((config) => {
    const token = localStorage.getItem('human_access_token')
    if (token) config.headers.Authorization = `Bearer ${token}`
    return config
  })
  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.status === 401) {
        localStorage.removeItem('human_access_token')
        localStorage.removeItem('human_info')
        window.location.href = '/human/login'
      }
      return Promise.reject(error)
    }
  )
  return instance
}

const humanClient = createHumanApiClient()

export const humanWorkspaceApi = {
  login: (data: { username: string; password: string; company_id: number }): Promise<HumanLoginResponse> =>
    humanClient.post('/human/auth/login', data).then(r => r.data),

  me: () =>
    humanClient.get('/human/auth/me').then(r => r.data),
}
